export const EGS_TABLE_COLUMN_WIDTHS = {
  name: { width: 300 },
  col2: 120,
  col3: 110,
  col4: 110,
  col5: 110,
  col6: 100,
  check: 90,
  action: 120,
  chevron: 48,
} as const;

// Capacity table has one fewer data column than Margin's (no Extra Guest Type equivalent),
// so its name column spans name + col2 and its remaining columns shift onto col3-col6 —
// keeps both tables' per-column and total widths aligned.
export const CAPACITY_NAME_COLUMN_WIDTH = EGS_TABLE_COLUMN_WIDTHS.name.width + EGS_TABLE_COLUMN_WIDTHS.col2;
